var population = [
  {raw_data: 20.73, selected: false},
  {raw_data: 21.48, selected: false},
  {raw_data:  9.51, selected: false},
  {raw_data: 22.54, selected: false},
  {raw_data: 16.93, selected: false},
  {raw_data: 26.98, selected: false},
  {raw_data: 24.85, selected: false},
  {raw_data: 28.96, selected: false},
  {raw_data: 19.91, selected: false},
  {raw_data: 26.15, selected: false},
  {raw_data: 30.49, selected: false},
  {raw_data: 22.40, selected: false},
  {raw_data: 25.74, selected: false},
  {raw_data: 15.77, selected: false},
  {raw_data: 20.74, selected: false},
  {raw_data: 22.88, selected: false},
  {raw_data: 16.97, selected: false},
  {raw_data: 25.97, selected: false},
  {raw_data: 31.51, selected: false},
  {raw_data: 22.19, selected: false},
  {raw_data: 19.39, selected: false},
  {raw_data: 18.29, selected: false},
  {raw_data: 10.96, selected: false},
  {raw_data: 21.98, selected: false},
  {raw_data: 19.66, selected: false},
  {raw_data: 22.70, selected: false},
  {raw_data: 27.91, selected: false},
  {raw_data: 16.05, selected: false},
  {raw_data: 31.08, selected: false},
  {raw_data: 27.34, selected: false},
  {raw_data: 19.89, selected: false},
  {raw_data: 18.44, selected: false},
  {raw_data: 14.06, selected: false},
  {raw_data: 23.09, selected: false},
  {raw_data: 13.05, selected: false},
  {raw_data: 26.63, selected: false},
  {raw_data: 24.41, selected: false},
  {raw_data: 32.63, selected: false},
  {raw_data: 30.42, selected: false},
  {raw_data: 21.31, selected: false},
  {raw_data: 28.31, selected: false},
  {raw_data: 28.59, selected: false},
  {raw_data: 16.86, selected: false},
  {raw_data: 25.98, selected: false},
  {raw_data: 28.59, selected: false},
  {raw_data: 31.48, selected: false},
  {raw_data: 21.35, selected: false},
  {raw_data: 16.90, selected: false},
  {raw_data: 24.49, selected: false},
  {raw_data: 31.56, selected: false},
  {raw_data: 27.82, selected: false},
  {raw_data: 24.11, selected: false},
  {raw_data: 22.58, selected: false},
  {raw_data: 26.63, selected: false},
  {raw_data: 19.45, selected: false},
  {raw_data: 25.63, selected: false},
  {raw_data: 17.57, selected: false},
  {raw_data: 23.78, selected: false},
  {raw_data: 19.39, selected: false},
  {raw_data: 17.23, selected: false},
  {raw_data: 16.76, selected: false},
  {raw_data: 21.73, selected: false},
  {raw_data: 13.19, selected: false},
  {raw_data: 18.39, selected: false},
  {raw_data: 25.38, selected: false},
  {raw_data: 14.48, selected: false},
  {raw_data: 25.67, selected: false},
  {raw_data: 33.90, selected: false},
  {raw_data: 32.79, selected: false},
  {raw_data: 19.25, selected: false},
  {raw_data: 29.22, selected: false},
  {raw_data: 25.60, selected: false},
  {raw_data: 22.10, selected: false},
  {raw_data: 17.76, selected: false},
  {raw_data: 22.69, selected: false},
  {raw_data: 24.05, selected: false},
  {raw_data: 19.51, selected: false},
  {raw_data: 21.92, selected: false},
  {raw_data: 18.35, selected: false},
  {raw_data: 11.43, selected: false},
  {raw_data: 22.16, selected: false},
  {raw_data: 28.80, selected: false},
  {raw_data: 25.11, selected: false},
  {raw_data: 15.03, selected: false},
  {raw_data: 25.07, selected: false},
  {raw_data: 32.08, selected: false},
  {raw_data: 16.05, selected: false},
  {raw_data: 21.32, selected: false},
  {raw_data: 30.74, selected: false},
  {raw_data: 30.59, selected: false},
  {raw_data: 23.79, selected: false},
  {raw_data:  8.79, selected: false},
  {raw_data: 12.61, selected: false},
  {raw_data: 24.89, selected: false},
  {raw_data: 12.76, selected: false},
  {raw_data: 12.42, selected: false},
  {raw_data: 18.14, selected: false},
  {raw_data: 21.71, selected: false},
  {raw_data: 21.86, selected: false},
  {raw_data: 23.17, selected: false},
]

population.map(item=>item.happiness=(item.raw_data-5)/30)

export default population
